import { compose } from 'ramda'
import { inject, listen } from '@k-ramel/react'
import { forRoute } from '@k-redux-router/react-k-ramel'
import loaderHoc from 'hoc-react-loader/build/core'
import messagesHoc from './messages'

export default ({
  mapStore,
  intl,
  listeners,
  screenName,
  name,
  loader,
} = {}, ...others) => {
  const features = []
  if (screenName) features.push(forRoute(screenName))
  if (listeners) features.push(listen(listeners, screenName || name))
  if (mapStore) features.push(inject(mapStore))
    if (intl) features.push(messagesHoc(intl))
  if (loader) {
    features.push(loaderHoc({
      ...loader,
    }))
  }
  features.concat(others)
  if (features.length === 0) {
    throw new Error('Container required a feature')
  } 
  return compose(...features)
}
